import { selectDoesUserHaveRbacPermission } from 'core/userContext';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { OverflowMenu } from 'ui/actionMenu';
import { Tooltip, TipPlacement } from 'ui/tooltip';
import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';

import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { pxToRem } from 'utils/convert';

import { List } from '../../domain';
import { useListModalContext } from '../context/ListModalContext';
import { Cell } from '../../components/table';
import { TABLE_COLUMNS } from '../constants';

interface ListOverflowMenuButtonProps {
  list: List;
}

const CellWrapper = styled(Cell)`
  height: ${pxToRem(90)};
  width: 100%;
`;

const displayContent = {
  remove: 'Remove from list',
  tooltip: 'You do not have permission to remove users from lists',
};

const OverflowWrapper = styled.div`
  position: absolute;
`;

export const ListOverflowMenuButton = ({ list }: ListOverflowMenuButtonProps) => {
  const { showListModalOptions } = useListModalContext();

  const canEditLists = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ManageSegmentation,
  );

  const options: ActionMenuOption[] = [];

  options.push({
    content: (
      <>
        <span>{displayContent.remove}</span>
      </>
    ),
    id: 'list-overflow-button',
    onClick: () => {
      showListModalOptions({ fromList: list });
    },
    as: AllowedActionMenuElements.Button,
  });

  return (
    <CellWrapper columnId={TABLE_COLUMNS.OVERFLOW} data-test={`list-overflow-menu-${list.name}`}>
      <OverflowWrapper id="list-overflow-wrapper">
        <Tooltip
          tooltipContent={displayContent.tooltip}
          placement={TipPlacement.Left}
          isEnabled={!canEditLists}
        >
          <OverflowMenu id="list-overflow-menu" options={options} isDisabled={!canEditLists} />
        </Tooltip>{' '}
      </OverflowWrapper>
    </CellWrapper>
  );
};
